module.exports = "<small>{{ 'reports.Total amount of entries' | translate }} {{ vm.list.pagination.totalCount }}</small>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paginationv2/tools/totalItems/template.html
// module id = 1617
// module chunks = 0